import { Rectangle } from 'flux-core';
import { IPoint2D } from 'flux-definition';
import { ConnectorTextModel } from './../../model/text/connector-text.mdl';
import { TextView } from './text-view';
import { IConnectorTextView } from 'flux-diagram-composer';

/**
 * This ConnectorTextView extends the TextView and it contains
 * the functialities the are specific to render the texts on the Connectors
 *
 * @author thisun
 * @since 2018-01-17
 */
export class ConnectorTextView extends TextView implements IConnectorTextView {
    constructor( model: ConnectorTextModel ) {
        super( model )/* istanbul ignore next */;
    }

    /**
     * This render's the text view as per the model data
     * and config. It also positions the text view in relation
     * to the shape
     * @param model ShapeTextModel
     * @param bounds Rectangle The bounds of the shape
     */
    public update( model: ConnectorTextModel, change?: any,  point?: IPoint2D ) {
        super.update( model, change );
        if ( point ) {
            let textBounds;
            /*  FIXME
                The model width property dhould not be undefined,
                Text width and height should be available at this point.
                But now, text width height are stored from the TextBoundsBinder change binder and
                these valuse are not avaibale for the first time texts render.
            */
            if ( model.width !== undefined ) {
                textBounds = new Rectangle( 0, 0, model.width, model.height );
            } else {
                textBounds = this.getTextBounds( model.value );
            }
            this.position( point, textBounds );
            this.updateHitArea( model, textBounds );
        }
        this.updateViewCache( model, change );
    }

    /**
     * This function updates the position of the text according to the
     * given point
     * @param point IPoint2D  The point to place the text
     */
    protected position( point: IPoint2D, textBounds: Rectangle ) {
        /*  FIXME
            The connector direction and position should decide the registration point.
            Right now it is always center but it has to change if the text is at the edge of the connector.
        */
        this.x = point.x - textBounds.width / 2;
        this.y = point.y - textBounds.height / 2;
    }

}
